import { SimpleGrid } from '@chakra-ui/layout';
import { Button } from '@chakra-ui/react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { GoogleIcon } from 'lib/icons/google';
import { SlackIcon } from 'lib/icons/slack';
const { publicRuntimeConfig: { genericRESTUrl } } = getConfig();

export const LoginProviders = () => {
  const router = useRouter();
  
  const onClickSlack = () => {
    router.push(`${genericRESTUrl}/v1/slack/identity`)
  }

  const onClickGoogle = () => {
    router.push(`${genericRESTUrl}/v1/google/identity`)
  }

  return (
    <SimpleGrid mt="6" columns={2} spacing="3">
      <Button variant="secondary" onClick={onClickGoogle}>
        <GoogleIcon /> Login with Google
      </Button>
      <Button variant="secondary" onClick={onClickSlack}>
        <SlackIcon /> Login with Slack
      </Button>
    </SimpleGrid>
  )
};
